'use strict';
//window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
//require('jquery');
require('materialize-css');
require('jquery-lazy');
require('slick-carousel');
require('sweetalert');
require('./contact');
var contLogin,campo,emailRegex;

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
        },0);
    }
    window.load = cargar();
    $('.sidenav').sidenav({
        edge: 'left'
    });
    $(".dropdown-trigger").dropdown({
        hover: false,
    });
});

$(document).ready(function () {
    $('#sliderBanner').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        cssEase: 'easeOutElastic',
        fade: true,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        customPaging: function (slider, i) {
            return '<a><img src="' + https + 'img/banner/dots.svg"/><img src="' + https + 'img/banner/dot-active.svg" /</a>';
        },
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    dotsClass: 'slick-dots',
                    customPaging: function (slider, i) {
                        //FYI just have a look at the object to find aviable information
                        //press f12 to access the console
                        //you could also debug or look in the source
                        console.log(slider);
                        var slideNumber = (i + 1),
                            totalSlides = slider.slideCount;
                        return '<a class="dot" role="button" title="' + slideNumber + ' of ' + totalSlides + '"><span class="string">·</span></a>';
                    }
                }
            }
        ]
    });

    $('.sectionBanner .slider-banner-float').slick({
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        lazyLoad: 'ondemand',
        prevArrow: $('.sectionBanner .slider-float .left'),
        nextArrow: $('.sectionBanner .slider-float .right'),
    });
    $('.sectionBanner .slider-float .arrow_first').css('height',$('.sectionBanner .slider-float .rowTwo').height()+'px');
});

$(window).scroll(function() {
    if ($(window).width() > 991) {
        if ($(document).scrollTop() > 96) {
            $('.header').css('background', '#ffffff', '!important');
            $('.header').addClass('header-shadow');
            $('.header .brand-logo .desktop').attr('src', https + 'img/header/logo_down.svg');
            $('.header').css('height', '85px', '!important');
            $('.header').css('line-height', '85px', '!important');
            $('.header a').css('color', '#0D85B7', '!important');
            $('.header .call').attr('src', https + 'img/header/call_2.svg');
            $('.header .wp').attr('src', https + 'img/header/wp_2.svg');

        } else {
            if ($(document).scrollTop() >= 0 && $(document).scrollTop() <= 85) {
                $('.header').css('background', 'transparent', '!important');
                $('.header').removeClass('header-shadow');
                $('.header .brand-logo .desktop').attr('src', https + 'img/header/logo.svg');
                $('.header').css('height', '100px', '!important');
                $('.header').css('line-height', '100px', '!important');
                $('.header a').css('color', '#ffffff', '!important');
                $('.header .call').attr('src', https + 'img/header/call.svg');
                $('.header .wp').attr('src', https + 'img/header/wp.svg');
            }
        }
    }
});

$(function(){
    let contView = 1,validate = 1,validateClickServices=1,validateClickPortfolio=1,validateClickContact=1;
    var element = $((document.getElementById('endPage')));
    validateScroll(element);

    $("img.lazy").Lazy({
        chainable: false,
        threshold: 500,
        visibleOnly: false,
    });
    $('.close-menu').click(function () {
        $('.sidenav').sidenav('close');
    });
    $('.clickAbout').click(function () {
        $('html, body').animate({
            scrollTop: $('#about').offset().top - 100
        }, 1000);
    });
    $('.clickServices').click(function () {
        if(validateClickServices == 1){
            var element = $((document.getElementById('header')));
            validateScroll(element);
            validateClickServices = 2
        }
        $('html, body').animate({
            scrollTop: $('#services').offset().top - 100
        }, 1000);
    });
    $('.clickPortfolio').click(function () {
        if(validateClickPortfolio == 1){
            var element = $((document.getElementById('header')));
            validateScroll(element);
            validateClickPortfolio = 2;
        }
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $('#portfolio').offset().top - 0
            }, 1000);
        },200)
    });
    $('.clickContact').click(function () {
        if(validateClickContact == 1){
            var element = $((document.getElementById('header')));
            validateScroll(element);
            validateClickContact = 2;
        }
        setTimeout(function () {
            $('html, body').animate({
                scrollTop: $('#contact').offset().top - 0
            }, 1000);
        },200)
    });

    $(window).scroll(function() {
        var element = $((document.getElementById('endPage')));
        validateScroll(element);
    });

    function validateScroll(element)
    {
        if(elementVisible(element)){
            if(validate == 2){
                return false
            }
            switch (contView) {
                case 1:
                    contView = 2;
                    $("#id_content_load").append(about);
                    $('footer').hide();

                    if ($(window).width() <= 600) {
                        var element = $((document.getElementById('header')));
                        validateScroll(element);
                    }
                    break;
                case 2:
                    contView = 3;
                    $("#id_content_load").append(services);
                    setTimeout(function () {
                        $('.modal').modal();
                        $('.sectionServices .element').click(function () {
                            $.ajax({
                                url: https + "getServices",
                                method: "POST",
                                data: {services_id:this.id,action:'getServices'},
                                success: function (data) {
                                    $('#modalServicio #modalView').html('');
                                    $('#modalServicio #modalView').html(data);
                                    $('#modalServicio').modal('open');
                                }
                            });
                        });
                    },10);
                    $("#id_content_load").append(brands);
                    setTimeout(function () {
                        $('#sliderBrands').slick({
                            dots: true,
                            infinite: true,
                            slidesToShow: 8,
                            slidesToScroll: 8,
                            adaptiveHeight: true,
                            arrows: false,
                            autoplay: false,
                            autoplaySpeed: 3000,
                            pauseOnHover: false,
                            pauseOnDotsHover: false,
                            pauseOnFocus: false,
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 6,
                                        slidesToScroll: 6,
                                        infinite: true,
                                        dots: true
                                    }
                                },
                                {
                                    breakpoint: 600,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 2
                                    }
                                },
                                {
                                    breakpoint: 480,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 1
                                    }
                                }
                             ]
                        });
                    });
                    $("#id_content_load").append(portfolio);
                    setTimeout(function () {
                        $('.sectionBanner .slider-banner-float').slick('slickSetOption',{
                            asNavFor: '#sliderPortfolio'
                        },true);
                        $('#sliderPortfolio').slick({
                            dots: true,
                            infinite: true,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            adaptiveHeight: true,
                            arrows: true,
                            autoplay: false,
                            autoplaySpeed: 3000,
                            pauseOnHover: false,
                            pauseOnDotsHover: false,
                            pauseOnFocus: false,
                            centerMode: true,
                            focusOnSelect:true,
                            lazyLoad: 'ondemand',
                            asNavFor: '.sectionBanner .slider-banner-float',
                            customPaging: function (slider, i) {
                                return '<a><img src="' + https + 'img/portfolio/dots.svg"/><img class="img-active" src="' + https + 'img/portfolio/dot-active.svg" /</a>';
                            },
                            prevArrow: $('.sliderPortfolio .arrows .left'),
                            nextArrow: $('.sliderPortfolio .arrows .right'),
                            responsive: [
                                {
                                    breakpoint: 600,
                                    settings: {
                                        slidesToShow: 1,
                                        slidesToScroll: 1,
                                        dots: false,
                                    }
                                }
                            ]
                        });
                    },10);
                    $("#id_content_load").append(instagram);
                    setTimeout(function () {
                        var access_token = location.hash.split('=')[1];
                        var URL_API_INSTAGRAM = "https://api.instagram.com/v1/users/"+instagram_id+"/media/recent/?count=15&access_token="+instagram_token+"&callback=?";
                        $.getJSON(URL_API_INSTAGRAM,function(data) {
                            var i = 1;
                            $('.instragramImages').html("");
                            $.each(data.data, function (item, value) {
                                if (i <= 6) {
                                    $('.instragramImages').append('' +
                                        '<div class="col s6 m4 l4 col-instagram">' +
                                        '<a target="_blank" href="' + data.data[item].link + '">' +
                                        '   <div class="containerInstagram">' +
                                        '       <div class="img">'+
                                        '           <img class="lazy" src="' + value.images.low_resolution.url + '" alt="">' +
                                        '       </div>'+
                                        '   </div>' +
                                        '</a>' +
                                        '</div>');
                                }
                                i++;
                            });
                        });
                    },10);
                    break;
                case 3:
                    contView = 4;
                    $('footer').show();
                    break;
            }
        }
    }

    function elementVisible(element) {
        var visible = true;
        var windowTop = $(document).scrollTop();
        var windowBottom = windowTop + window.innerHeight;
        var elementPositionTop = element.offset().top;
        var elementPositionBottom = elementPositionTop + element.height();
        if (elementPositionTop >= windowBottom || elementPositionBottom <= windowTop) {
            visible = false;
        }
        return visible;
    }
});

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});